var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup show-popup"},[_c('div',{staticClass:"popup-content"},[_c('h4',[_vm._v("Aktivacija dostopa je uspešno končana.")]),_vm._v(" "),_c('p',{staticClass:"bottom"},[_c('a',{staticClass:"button green",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[_vm._v("Naprej")])])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a5ba3c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PopupActivationSuccess.vue
// module id = /TYF
// module chunks = 0